import React from 'react';
import '../../../../Context/index.js';
import { LinkCollection } from '../LinkCollection/index.js';
import { SimpleLink } from '../SimpleLink/index.js';
import { ContentCollection } from '../ContentCollection/index.js';
import { LinkCollectionV2 } from '../LinkCollectionV2/index.js';
import { VipLink } from '../VipLink/index.js';
import { useLayoutContext } from '../../../../Context/utils/useLayoutContext.js';

const RenderExpandedMenu = ({ menu }) => {
  const { menuExpandedLinkCollection, setMenuExpandedLinkCollection } = useLayoutContext();
  return menu.map(({ key, ...props }) => {
    if (props.kind === "linkCollection") {
      return /* @__PURE__ */ React.createElement(
        LinkCollection,
        {
          ...props,
          key,
          isExpanded: menuExpandedLinkCollection === props.name,
          onExpand: (isExpanded) => {
            setMenuExpandedLinkCollection(isExpanded ? props.name : "");
          }
        }
      );
    }
    if (props.kind === "tabLinkCollection") {
      return /* @__PURE__ */ React.createElement(
        LinkCollectionV2,
        {
          ...props,
          key,
          isExpanded: menuExpandedLinkCollection === props.name,
          onExpand: (isExpanded) => {
            setMenuExpandedLinkCollection(isExpanded ? props.name : "");
          }
        }
      );
    }
    if (props.kind === "link") {
      return /* @__PURE__ */ React.createElement(SimpleLink, { key, ...props });
    }
    if (props.kind === "vip") {
      return /* @__PURE__ */ React.createElement(VipLink, { key, ...props });
    }
    if (props.kind === "node") {
      return /* @__PURE__ */ React.createElement(
        ContentCollection,
        {
          ...props,
          key,
          isExpanded: menuExpandedLinkCollection === props.name,
          onExpand: (isExpanded) => {
            setMenuExpandedLinkCollection(isExpanded ? props.name : "");
          }
        }
      );
    }
    return null;
  });
};

export { RenderExpandedMenu };
//# sourceMappingURL=index.js.map
